module.exports = __webpack_public_path__ + "img/volcano.dec350a4.jpg";